import { CreateStudentApplicationForm } from '~/modules/applications/components/CreateStudentApplicationForm/CreateStudentApplicationForm';
import { useState } from 'react';
import { ApplicationIntro } from '~/modules/applications/components/ApplicationIntro/ApplicationIntro';
import { useParams } from 'react-router-dom';
import { useGetCourse } from '~/modules/applications/models/application.hooks';

const pages = {
  intro: 'intro',
  form: 'form',
};

export const CreateStudentApplication = () => {
  const { id } = useParams();
  const course = useGetCourse(id);
  const [page, setPage] = useState(pages.intro);

  const nextPageCallback = () => {
    setPage(pages.form);
  };

  const previousPageCallback = () => {
    setPage(pages.intro);
  };

  if (!course) {
    return null;
  }

  return (
    <div className="create-student-application">
      {page === pages.form && <CreateStudentApplicationForm previousPage={previousPageCallback} course={course} />}
      {page === pages.intro && (
        <ApplicationIntro
          title={'Student Application - ' + course.name}
          text={course.student_application_intro}
          description={course.description}
          nextPage={nextPageCallback}
        />
      )}
    </div>
  );
};
